import React from 'react'
import Rentree from '../../Page/Admis/rentree.js';

export default function misc() {
    return (
        <div className="divecole4 fifty">
            <div className='imglogopartnaire'>
                <img 
                    className='logoPartenaire2' 
                    src="images/partenaire/unvop.png" 
                    style={{ paddingLeft: '0.2%', paddingBottom: '0.2%', width:"70%" }} 
                />
            </div>
            <br />  
            <a style={{ fontSize: '18px', color: '#4e95ac' }}>
                Université du Littoral Côte d'Opale <Rentree />
            </a>
            <br /> <br/>
            <p style={{ fontWeight: "800", fontSize: "1.5rem" }}>
                TERRAB MAASKRI AYA - <span style={{ color: "#4cb6ea", fontSize: "1.5rem" }}>M2 Master Ingénierie Des Systèmes Complexes</span>
            </p>
            <p style={{ fontWeight: "800", fontSize: "1.5rem" }}>
                ABDALLAOUI ALAOUI OMAR - <span style={{ color: "#4cb6ea", fontSize: "1.5rem" }}>M2 Master Ingénierie Des Systèmes Complexes</span>
            </p>
        </div>
    )
}
